// src/table/mergeRows.ts
function mergeStreamedRows(streamed, fetched, rowKey, max = 1e3, deleted) {
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const row of [...streamed, ...fetched]) {
    const key = rowKey(row);
    if (key !== null) {
      if (seen.has(key) || deleted?.has(key)) continue;
      seen.add(key);
    }
    out.push(row);
    if (out.length >= max) break;
  }
  return out;
}

export { mergeStreamedRows };
//# sourceMappingURL=chunk-EBRJYXG7.js.map
//# sourceMappingURL=chunk-EBRJYXG7.js.map